import _ from 'lodash'
import React, { memo } from 'react'
import PropTypes from 'prop-types'
import fastDeepEqual from 'fast-deep-equal'
import * as graph from '@adc/sdk'
import {
  ListingCard,
  withApplicationNotificationsContext,
  getNullApplicationNotifications,
  utils,
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import { LISTING_CARD, trackPropertyClick } from '../../services/analytics'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const ListingCardWrapper = ({
  listing,
  elmId,
  isSaved,
  position,
  resultSection,
  toggleSaveAsset,
  updateSelectedId,
  updateOpenedAsset,
  featureFlags = {},
  showAdContent,
  isFocused,
  notifications = getNullApplicationNotifications(),
  updateVerifiedImage,
  verifiedImage,
  trackingContext = {},
}) => {
  const onMouseEnter = e => {
    e.stopPropagation()
    updateSelectedId(listing.listing_id)
  }

  const handleToggleSaveAsset = (_event, analyticsData = {}) => {
    toggleSaveAsset({
      listing,
      updateListingSavedCallback: _.noop,
      ...trackingContext,
      ...analyticsData,
      resultSection,
      position,
      notifications,
    })
  }

  const onClickAsset = (listingData = {}) => {
    trackPropertyClick({
      listing,
      triggeredFrom: LISTING_CARD,
      index: position,
      ...trackingContext,
      ...listingData,
      resultSection,
    })
    updateOpenedAsset(listing.listing_id)
  }

  const isCancelled =
    listing?.listing_status === graph.enums.ListingStatusGroup.Canceled
  const listingId = listing?.listing_id ?? null
  // ad content listing card doesn't require full data
  if (listingId === null && !showAdContent) {
    return null
  }

  return (
    <div
      data-elm-id={`${elmId}_root`}
      data-position={`${position}`}
      className={cx('asset-root')}
      onMouseEnter={!utils.isTouchDevice() ? onMouseEnter : undefined}
    >
      <ListingCard
        listing={listing}
        elmId={elmId}
        isSaved={isSaved}
        linkProps={{
          onClick: !isCancelled ? onClickAsset : null,
          href: listing.listing_page_path,
          target: '_blank',
          rel: 'noopener noreferrer',
        }}
        showSave
        onSaveToggle={!isCancelled ? handleToggleSaveAsset : null}
        showV2
        isCancelled={isCancelled}
        featureFlags={featureFlags}
        isFocused={isFocused}
        showAdContent={Boolean(showAdContent)}
        verifiedImage={verifiedImage}
        updateVerifiedImage={updateVerifiedImage}
      />
    </div>
  )
}

ListingCardWrapper.propTypes = {
  listing: PropTypes.object.isRequired,
  elmId: PropTypes.string.isRequired,
  isSaved: PropTypes.bool.isRequired,
  position: PropTypes.number,
  resultSection: PropTypes.string,
  toggleSaveAsset: PropTypes.func.isRequired,
  updateSelectedId: PropTypes.func.isRequired,
  updateOpenedAsset: PropTypes.func.isRequired,
  featureFlags: PropTypes.object,
  showAdContent: PropTypes.bool.isRequired,
  isFocused: PropTypes.bool,
  notifications: PropTypes.object,
  updateVerifiedImage: PropTypes.func.isRequired,
  verifiedImage: PropTypes.string,
  trackingContext: PropTypes.object,
}

const MemoizedListingCardWrapper = memo(
  ListingCardWrapper,
  (prevProps, nextProps) => {
    const isRawAssetEqual = fastDeepEqual(nextProps.listing, prevProps.listing)
    const isSavedAssetEqual = fastDeepEqual(
      nextProps.isSaved,
      prevProps.isSaved
    )
    return isRawAssetEqual && isSavedAssetEqual
  }
)

export { ListingCardWrapper }
export default withApplicationNotificationsContext(MemoizedListingCardWrapper)
